import { useState, useEffect } from 'react'
import { GrLocation, GrGlobe} from 'react-icons/gr'
import { BsChatSquareText, BsChatText } from 'react-icons/bs'
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaTiktok, FaTumblr, FaDiscord} from 'react-icons/fa'

import Social from '../buttons/Social'
import './aside.css'

const Aside = ({data}) => {

      const {banners, infordata, social} = data.user 
      const id_xat = infordata.id_xat 
      const [online, setOnline] = useState([])

      async function getOnline(id){
            try{
                  const response = await fetch(`https://oceanbot.net/online.php?id=${id}`)
                  const result = await response.json()
                  setOnline(result)
            }
            catch(err){
                  console.log('Error: ', err)
            }
      }

      useEffect(() => {
            getOnline(id_xat)
      }, [id_xat])

      return (
            <div className="aside_content">
                  <div className="aside_top">
                        <p>{banners?.data ? "Welcome to my xatspace!" : banners[0].title}</p>
                        <div className="aside_top__title">
                              <h1>{infordata.name}</h1>
                              <h2>{infordata.status}</h2>
                        </div>
                  </div>
                  <div className="aside_user">
                        <div className="aside_user__header">
                              <div className="aside_user__header_avatar">
                                    <img src={infordata.avatar} alt={infordata.name} />
                                    <div className={online.status === 'online' ? "user_online green" : "user_online red"}></div>
                              </div>
                              <div className="aside_user__data">
                                    <strong className="bg_grad">{infordata.name}</strong>
                                    <span>{online.status === 'online' ? "Online Now" : "Offline"}</span>
                              </div>
                        </div>
                        <div className="aside_user_content">
                              <p>{infordata.about}</p>
                        </div>
                        <div className="aside_user__footer">
                              <div className="user_location">
                                    <div className="user_location__icon">
                                          <GrLocation />
                                    </div>
                                    <div className="user_location__data">
                                          <span>Location</span>
                                          <strong className="bg_grad">{infordata.location}</strong>
                                    </div>
                              </div>
                              <div className="user_menu">
                                    <a href={infordata.homepage || "https://xat.com"} target="_blank" rel="noreferrer" data-tooltip="Homepage"><GrGlobe /></a>
                                    <a href={infordata.xat_room || "https://xat.com"} target="_blank" rel="noreferrer" data-tooltip="XatRoom"><BsChatSquareText /></a>
                                    <a href={infordata.forum || "https://forum.xat.com"} target="_blank" rel="noreferrer" data-tooltip="Forum"><BsChatText /></a>
                              </div>
                        </div>
                  </div>
                  <div className="aside_footer">
                        <div className="aside_footer__id">
                              <h2>{infordata.id_xat}</h2>
                              <span>Xat Id</span>
                        </div>
                        <div className="aside_footer__social">
                              <span>Social</span>
                              <div className="social_menu">
                                    <Social link={social?.facebook || "https://www.facebook.com"} icon={<FaFacebookF />} />
                                    <Social link={social?.twitter || "https://www.twitter.com"} icon={<FaTwitter />} />
                                    <Social link={social?.instagram || "https://www.instagram.com"} icon={<FaInstagram />} />
                                    <Social link={social?.youtube || "https://www.youtube.com"} icon={<FaYoutube />} />
                                    <Social link={social?.tiktok || "https://www.tiktok.com"} icon={<FaTiktok />} />
                                    <Social link={social?.tumblr || "https://www.tumblr.com"} icon={<FaTumblr />} />
                                    <Social link={social?.discord || "https://www.discord.com"} icon={<FaDiscord />} />
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Aside
